module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoLego.a9f1afa1.png";